// External links into the existing Clearview product (cgclearview.app).
// This new marketing site MUST NOT host /app, /login, or /signup routes.
export const SIGNUP_URL = "https://www.cgclearview.app/signup";
export const LOGIN_URL = "https://www.cgclearview.app/login";
export const CONTACT_EMAIL = "founders@cgclearview.app";
export const SITE_URL = "https://cgclearview.app";
